/**
 * Utility for handling images and preventing PDFs from being used as image sources
 */

/**
 * Checks if a file path is a PDF
 * @param {string} path - File path to check
 * @returns {boolean} - True if the path is a PDF file
 */
export const isPdfFile = (path) => {
  if (!path) return false;
  return path.toLowerCase().endsWith('.pdf');
};

/**
 * Gets a safe image URL, returning null if the source is a PDF
 * @param {string} src - Original image source
 * @returns {string|null} - Safe image URL or null if invalid
 */
export const getSafeImageUrl = (src) => {
  if (!src || isPdfFile(src)) {
    return null;
  }
  return src;
};

/**
 * Creates a patch for the global Image constructor to prevent PDFs being loaded
 * Call this function early in your application initialization
 */
export const patchImageSources = () => {
  // Save original Image constructor
  const OriginalImage = window.Image;
  
  // Create a new Image constructor that filters PDFs
  window.Image = function() {
    const img = new OriginalImage();
    
    // Override the src setter
    const originalSrcDescriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    Object.defineProperty(img, 'src', {
      get: originalSrcDescriptor.get,
      set: function(value) {
        // Check if it's a PDF and prevent setting
        if (value && isPdfFile(value)) {
          console.warn('Prevented loading PDF as image:', value);
          // Set to a placeholder instead
          originalSrcDescriptor.set.call(this, 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y1ZjVmNSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMjAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiM5OTkiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==');
        } else {
          originalSrcDescriptor.set.call(this, value);
        }
      },
      enumerable: true,
      configurable: true
    });
    
    return img;
  };
  window.Image.prototype = OriginalImage.prototype;
  
//   console.log('Image sources patched to prevent PDFs from loading as images');
};
